export default __webpack_public_path__ + "static/media/mobile-version.24ac3d14.png";